import {
  TableColumnWidthInfo,
  DataTypeProvider,
  Column,
  Sorting,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  PagingPanel,
  SearchPanel,
  Table,
  TableColumnResizing,
  TableHeaderRow,
  Toolbar,
} from '@devexpress/dx-react-grid-bootstrap4'
import useInit from './hooks/useInit'
import Entity from '../types/Entity'
import { useState } from 'react'
import { Form } from 'react-bootstrap'
import handleToggleActiveParent from '../utils/handleToggleActive'
import useInitColumns from '../hooks/useInitColumns'

interface TableExcludedRowsProps {
  rows: Array<Entity>
  setRows: Function
  relationalFieldName: string
  toggleActiveUrl?: string
  handleIncludeRow: (row: Entity) => void
  disableActions: boolean
  setDisableActions: Function
  handleModalRowEdit?: (row: Entity) => void
  showSearch: boolean
  showPagination: boolean
}

const TableExcludedRows: React.FunctionComponent<TableExcludedRowsProps> = (
  props: TableExcludedRowsProps,
) => {
  const [columns, setColumns] = useState<Array<Column>>([])

  const [defaultSorting, setDefaultSorting] = useState<Array<Sorting>>([])

  const [columnWidths, setColumnWidths] = useState<TableColumnWidthInfo[]>([])

  const handleToggleActive = (row: Entity) => {
    return handleToggleActiveParent({
      row: row,
      relationalFieldName: props.relationalFieldName,
      url: props.toggleActiveUrl ?? '',
      rows: props.rows,
      setRows: props.setRows,
      setDisableActions: props.setDisableActions,
    })
  }

  const [activeFormatter] = useState<any>({
    for: ['active'],
    formatterComponent: (props) => {
      if (props.row?.greyOutIncluded === true) {
        return null
      }
      return (
        <Form.Check
          type='switch'
          onChange={() => {
            handleToggleActive(props.row)
          }}
          disabled={props.disableActions}
          checked={props.value}
        />
      )
    },
    editorComponent: undefined,
    availableFilterOperations: undefined,
  })

  const [nameFormatter] = useState<any>({
    for: ['name'],
    formatterComponent: (props) => {
      if (props.row?.greyOutIncluded === true) {
        let classes : string = 'text-muted'
        if (props.row?.isRecent === true) {
          classes += ' recent-filter-value mx-8'
        }
        return <span className={classes}>{props.row.name} (selected)</span>
      }
      
      if (props.row?.isRecent === true) {
        return <span className='recent-filter-value mx-8'>{props.row.name}</span>
      }
      return props.row.name
    },
    editorComponent: undefined,
    availableFilterOperations: undefined,
  })

  useInit({
    rows: props.rows,
    handleIncludeRow: props.handleIncludeRow,
    disableActions: props.disableActions,
    handleModalRowEdit: props.handleModalRowEdit,
  })

  useInitColumns({
    setColumns,
    setColumnWidths,
    setDefaultSorting,
    toggleActiveUrl: props.toggleActiveUrl,
    sortRowsUrl: undefined,
  })

  const CellComponent = (props) => {

    const level = props?.row?.level ?? 0
    const paddingLeft = level * 10

    return <Table.Cell 
              {...props} 
              style={{
                ...props.style,
                paddingLeft: `${paddingLeft}px`,
              }} 
            />
  }

  const PagingContainer = (props) => {
    return <PagingPanel.Container {...props} className='table-footer' />
  }

  const SearchPanelInput = (props) => {
    return  <SearchPanel.Input {...props} className='w-100 inline-space-r search-input' />
  }

  return (
    <>
      <Grid rows={props.rows} columns={columns}>
        <DataTypeProvider {...activeFormatter} />
        <DataTypeProvider {...nameFormatter} />
        {props.showSearch && <SearchState defaultValue='' />}
        {props.showSearch && <IntegratedFiltering /> }
        {props.showPagination && <PagingState defaultCurrentPage={0} pageSize={15} />}
        {props.showPagination && <IntegratedPaging />}
        {props.showSearch && <Toolbar />}
        {props.showSearch && <SearchPanel inputComponent={SearchPanelInput} />}
        <Table cellComponent={CellComponent} />
        <TableColumnResizing
          defaultColumnWidths={columnWidths}
          columnWidths={columnWidths}
          onColumnWidthsChange={(nextColumnWidths: Array<TableColumnWidthInfo>) => {
            setColumnWidths(nextColumnWidths)
          }}
          resizingMode='nextColumn'
        />
        <TableHeaderRow />
        {props.showPagination && <PagingPanel pageSizes={[]} containerComponent={PagingContainer} />}
      </Grid>
    </>
  )
}

export default TableExcludedRows
